import { render, staticRenderFns } from "./PageMainHome.vue?vue&type=template&id=216a71b0&scoped=true"
import script from "./PageMainHome.vue?vue&type=script&lang=js"
export * from "./PageMainHome.vue?vue&type=script&lang=js"
import style0 from "./PageMainHome.vue?vue&type=style&index=0&id=216a71b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216a71b0",
  null
  
)

export default component.exports